






































import { SettingsVueGB } from "@/extensions/settings/SettingsVueGB";
import { Component } from "vue-property-decorator";
import VerifyBox from "@/components/app/VerifyBox.vue";
import BackLink from "@/components/app/BackLink.vue";
import SbpEnableModal from "@/components/settings/SbpEnableModal.vue";
import DefaultOutAccount from "@/components/settings/DefaultOutAccount.vue";
import AccountInDefaultModal from "@/components/settings/AccountInDefaultModal.vue";
import BankSelectModal from "@/components/settings/BankSelectModal.vue";
import SbpDefaultModal from "@/components/settings/SbpDefaultModal.vue";

@Component({
  components: { 
    VerifyBox, 
    BackLink, 
    SbpDefaultModal,
    BankSelectModal,
    SbpEnableModal,
    AccountInDefaultModal,
    DefaultOutAccount
  },
})
export default class TransfersPhoneModal extends SettingsVueGB {
}
